import { debounce } from 'throttle-debounce';
import SimpleHashTable from 'simple-hashtable';
import Util from './util';
import Tracking from './tracking';

const UpdateUrlAndTrack = debounce(1000, id => {
	Util.UpdateUrlHash(id);
	Tracking.TrackPageView(`${window.location.pathname}#${id}`);
});

const FracTracking = {
	trackAll: false,
	allRefs: document.querySelectorAll('.nav a.fracs'),
	found: null,
	max: 0,
	min: 0.1,
	current: new SimpleHashTable(),
	Init() {
		FracTracking.Fracs();
	},
	Callback(entries) {
		FracTracking.found = null;
		FracTracking.max = 0;

		let entryId = 0;
		entries.forEach(entry => {
			entryId = entry.target.id;
			if (entry.isIntersecting) {
				if (entry.intersectionRatio > FracTracking.min) {
					FracTracking.current.put(entryId, entry);
				}
			} else if (FracTracking.current.containsKey(entryId)) {
				FracTracking.current.remove(entryId);
			}
		});

		let entry = null;
		FracTracking.current.keys().forEach(key => {
			if (FracTracking.current.containsKey(key)) {
				entry = FracTracking.current.get(key);
				if (entry.isIntersecting && entry.intersectionRatio > FracTracking.max) {
					FracTracking.max = entry.intersectionRatio;
					FracTracking.found = entry;
				}
			}
		});

		if (FracTracking.found != null) {
			FracTracking.allRefs.forEach(ref => {
				ref.classList.remove('active');
			});

			const id = FracTracking.found.target.getAttribute('id');
			const reference = document.querySelector(`.nav a.fracs[href="#${id}"]`);
			if (reference != null) {
				reference.classList.add('active');
				FracTracking.allRefs.forEach(ref => {
					ref.blur();
				});
			}

			if (FracTracking.trackAll || !FracTracking.found.target.classList.contains('frac-notracking')) {
				FracTracking.trackAll = true;
				UpdateUrlAndTrack(id);
			}
		}
	},
	Fracs() {
		const observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: [0, 0.25, 0.5, 0.75, 1]
		};

		const observer = new IntersectionObserver(FracTracking.Callback, observerOptions);

		const triggers = document.querySelectorAll('.frac');

		triggers.forEach(trigger => {
			observer.observe(trigger);
		});
	}
};

export default FracTracking;
